import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Shimmer } from '@wartek-id/shimmer'

import { useAPIGetKepalaSekolahEligibility } from 'api/bcks/useAPIBCKSQualification'

import type { HTMLProps } from 'react'

const BCKSProfile = ({ className, ...props }: HTMLProps<HTMLDivElement>) => {
  const { data: profile, isLoading: isLoadingProfile } =
    useAPIGetKepalaSekolahEligibility()

  return (
    <div
      className={clsx('bg-white px-4 py-3 space-y-1.5', className)}
      {...props}
    >
      {isLoadingProfile ? (
        <>
          <Shimmer />
          <Shimmer />
        </>
      ) : (
        <>
          <Text variant="heading-sm">{profile?.identity.nama.value}</Text>
          <Text variant="body-sm" color="subdued">
            NIP: {profile?.identity.nip.value}
          </Text>
        </>
      )}
    </div>
  )
}

export default BCKSProfile
